//给js原始对象添加一些方法，或者是复写，因为有些浏览器不支持某些方法。

Array.prototype.flat = function() {
  //扁平化数组
  const stack = [...this];
  const res = [];
  while (stack.length) {
    const next = stack.pop();
    if (Array.isArray(next)) {
      //如果是数组就结构 再次添加到stack
      stack.push(...next);
    } else {
      //否则添加到next
      res.push(next);
    }
  }
  //颠倒数组为原本顺序 返回
  return res.reverse();
};
